import React from 'react';
import { Section } from './ui/Section';
import { TestimonialCard } from './ui/TestimonialCard';
export function ExtendedTestimonials() {
  const testimonials = [{
    quote: 'Compré un domingo a la noche. El lunes entré al gym con el plan exacto de la clase. Los WODs del Tomo 2 son exactamente lo que necesitaba para mis grupos de todos los niveles. Nunca más improviso.',
    name: 'Rodrigo M.',
    location: 'Buenos Aires',
    role: 'Profe de Funcional en Gimnasio Propio'
  }, {
    quote: 'El Tomo 3, el de HIIT y ABS, me cambió todo. El primer mes, alumnos que llevaban meses estancados mejoraron visiblemente su resistencia y su definición. Los protocolos listos me dan la tranquilidad que antes no tenía.',
    name: 'Martín G.',
    location: 'Rosario',
    role: 'Profe en Box de CrossFit y Clases Grupales'
  }, {
    quote: 'El banco de WODs del Tomo 2 es único en el mercado. 50 WODs listos para usar, con todos los formatos descriptos. Antes tardaba horas armando un WOD. Ahora abro el PDF y en 5 minutos tengo todo listo.',
    name: 'Luciana F.',
    location: 'Córdoba',
    role: 'Profe de Funcional Grupal e Individual'
  }, {
    quote: 'La Guía de 3 Niveles eliminó el problema del grupo heterogéneo. Ahora muestro las 3 versiones del WOD y cada alumno elige la que le corresponde. Los avanzados se sienten desafiados y los principiantes se sienten seguros.',
    name: 'Diego P.',
    location: 'Tucumán',
    role: 'Profe Particular y en Gimnasio'
  }, {
    quote: 'La tasa de abandono de mis grupos bajó muchísimo. Sin cambiar lo que enseño. Solo aplicando el sistema de progresión mensual del Tomo 4 y la variedad de los 6 tomos. Los alumnos ahora quieren venir porque siempre hay algo nuevo.',
    name: 'Daniela G.',
    location: 'Mendoza',
    role: 'Profe de Funcional Online y Presencial'
  }, {
    quote: 'El Tomo 6 me cambió la cabeza. Nunca había dimensionado cuánto dinero dejaba sobre la mesa sin un sistema claro de precios y retención. Ahora trabajo con una rentabilidad que antes no tenía.',
    name: 'Pablo V.',
    location: 'Santa Fe',
    role: 'Profe de Funcional en Estudio Propio'
  }, {
    quote: 'El Elite Coach 360 me cambió todo. Nunca había dimensionado el riesgo que corría sin adaptaciones claras para mis alumnos con condiciones especiales. Ahora trabajo con una tranquilidad que antes no tenía.',
    name: 'Ana R.',
    location: 'Salta',
    role: 'Profe en Centro de Salud y Rehabilitación'
  }];
  return <Section bg="dark-900" data-id="element-110">
      <div className="text-center mb-8 md:mb-16" data-id="element-111">
        <h2 className="text-2xl md:text-4xl font-display font-bold text-white mb-3 md:mb-6" data-id="element-112">
          Lo que dicen los profes que ya lo usan:
        </h2>
        <p className="text-base md:text-xl text-lime-400 font-medium max-w-2xl mx-auto" data-id="element-113">
          +300 profes de funcional y cross training de todo el país ya tienen su
          FUNCIONAL & CROSS 360
        </p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 max-w-7xl mx-auto" data-id="element-114">
        {testimonials.map((t, i) => <div key={i} className={i === testimonials.length - 1 ? 'md:col-span-2 lg:col-span-1' : ''} data-id="element-115">
            <TestimonialCard {...t} data-id="element-116" />
          </div>)}
      </div>
    </Section>;
}